module.exports = __webpack_public_path__ + "static/media/Icono documento.4c54cd77.svg";